import { render, staticRenderFns } from "./indexButtonsInverter.vue?vue&type=template&id=023ae8f6"
import script from "./indexButtonsInverter.vue?vue&type=script&lang=js"
export * from "./indexButtonsInverter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports